import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HttpClientModule } from '@angular/common/http';
import { SubscriptionsComponent } from './subscriptions/subscriptions.component';
import { TopbarComponent } from './topbar/topbar.component';
import { ProfileComponent } from './profile/profile.component';
import { SignupComponent } from './signup/signup.component';
import { ManageSubscriptionsComponent } from './manage-subscriptions/manage-subscriptions.component';
//import * as $ from 'jquery';
//import * as bootstrap from "bootstrap";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { PasswordSuccessComponent } from './password-success/password-success.component';
//import { CompanyStoresComponent } from './company-stores/company-stores.component';
import { AddCompanyStoresComponent } from './add-company-stores/add-company-stores.component';

import { ColorPickerModule } from 'ngx-color-picker';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddProductSubscriptionsComponent } from './add-product-subscriptions/add-product-subscriptions.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ProductPaymentComponent } from './product-payment/product-payment.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { NgxSpinnerModule } from "ngx-spinner";  
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OrderSuccessComponent } from './order-success/order-success.component'; 
import {NgxImageCompressService} from 'ngx-image-compress';
import { ManageCompanyComponent } from './manage-company/manage-company.component';
import { AllotLicenseComponent } from './allot-license/allot-license.component';
import { CreateAdminComponent } from './create-admin/create-admin.component';
import { AddStoreComponent } from './add-store/add-store.component';
import { TermsComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { SubAdminComponent } from './sub-admin/sub-admin.component';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SubscriptionsComponent,
    TopbarComponent,
    ProfileComponent,
    SignupComponent,
    ManageSubscriptionsComponent,
    ForgotPasswordComponent,
    PasswordSuccessComponent,
    //CompanyStoresComponent,
    AddCompanyStoresComponent,
    DashboardComponent,
    AddProductSubscriptionsComponent,
    NotificationsComponent,
    ProductPaymentComponent,
    CheckoutComponent,
    OrderSuccessComponent,
    ManageCompanyComponent,
    AllotLicenseComponent,
    CreateAdminComponent,
    AddStoreComponent,
    TermsComponent,
    PrivacyComponent,
    ResetPasswordComponent,
    AdminUsersComponent,
    SubAdminComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    NgxMaskModule.forRoot(),
  ],
  exports: [TopbarComponent],
  providers: [NgxImageCompressService],
  bootstrap: [AppComponent]
})
export class AppModule { }
